export const CONSTRAINTS = {
  name: {
    presence: { allowEmpty: false, message: 'is required' },
    length: { minimum: 3, message: 'must be at least 3 characters' },
  },
};

export const DEBOUNCE_DELAY = 1000;

export const LIMITED_USER_ACCESS_EDIT_ALLOWED = 'Allow Editing for Full Access Viewers';
